// predictive-search-tabs.js
// Place this file in your theme's assets/ folder
// Then add this to your theme.liquid inside <head>:
// <script src="{{ 'predictive-search-tabs.js' | asset_url }}" defer></script>

document.addEventListener('click', function(e) {
  var tab = e.target.closest('[data-sr-tab]');
  if (!tab) return;

  var name = tab.getAttribute('data-sr-tab');
  var nav = tab.closest('.sr-tab-nav');

  // update tab active states
  nav.querySelectorAll('[data-sr-tab]').forEach(function(t) {
    t.classList.toggle('sr-tab--active', t.getAttribute('data-sr-tab') === name);
  });

  // show/hide panels
  document.querySelectorAll('.sr-panel').forEach(function(p) {
    p.style.display = p.id === 'sr-panel-' + name ? '' : 'none';
  });
});